window.socialMedia = function(){

  let JSShare = require('js-share');// import JSShare from "js-share";

  let shareItems = document.querySelectorAll('.social_share');
  JSShare.options.url = window.location.href;
  for (let i = 0; i < shareItems.length; i += 1) {
    shareItems[i].addEventListener('click', function share(e) {
      return JSShare.go(this);
    });
  }
}
